<template>
    <v-autocomplete
      v-model="model"
      :items="locationsComputed"
      item-value="id"
      item-text="name"
      :label="displayLabel ? $_t('Patient location') : ''"
      :loading="loading"
      :required="mandatory"
      :rules="checkRules"
      :error="showError"
      :multiple="multiple"
      clearable
    />
</template>

<script>
export default {
  name: 'PatientLocationDropdown',
  props: {
    value: {
      type: [String, Array],
      default: undefined
    },
    mandatory: {
      type:Boolean,
      defualt: false
    },
    displayLabel: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    checkRules(){
      if(this.mandatory) {
      return (this.model) ? [] : [this.$_t('Required')]

      } else {
        return []
      }
    },
    locationsComputed () {
      return this.locations.filter(location => {
        if (location.isActive) {
          return true
        }
          
        // Handle both single value and array for multiple selection
        if (Array.isArray(this.model)) {
          return this.model.includes(location.id)
        } else {
          return location.id === this.model
        }
      })
    },
    showError(){
      if(this.mandatory) {
        return (this.model) ? false : true

      } else {
        return false
      }
    }

  },
  data () {
    return {
      locations: [],
      loading: false
    }
  },
  mounted () {
    this.getLocations()
  },
  methods: {
    getLocations () {
      this.loading = true
      this.$_rest.get(`/practitioners/${ this.$store.getters['app/currentUserId'] }/patient-locations`, { limit: 10000 }, response => {
        this.loading = false
        this.locations = response.data
      }, error => {
        this.loading = false
        this.$_notify.error(error)
      }, {
        prefixRoutesWithOrganizationId: true
      })
    }
  }
}
</script>

<style scoped>

</style>
